import { HttpRequest, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HttpErrorHandler, Priority, HttpResponseStatus, OccEndpointsService, BaseSiteService, GlobalMessageService } from "@spartacus/core";
import { take } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class UnauthorizedForbiddenHandlerService extends HttpErrorHandler {

  baseSiteId: any;

  getPriority?(): Priority;

  responseStatus = HttpResponseStatus.UNAUTHORIZED;
  constructor(
    protected globalMessageService: GlobalMessageService,
    private baseSiteService: BaseSiteService,
    private occEndPoint: OccEndpointsService
  ) {
    super(
      globalMessageService
    );
  }
  handleError(request: HttpRequest<any>, errorResponse: HttpErrorResponse) {
    this.baseSiteService
    .getActive()
    .pipe(take(1))
    .subscribe((res) => {
      this.baseSiteId = res;
    })
    if (errorResponse.error.hasOwnProperty('errors')) {  
      if(localStorage.getItem('asm_enabled') == 'true' && (errorResponse.error.error == 'invalid_token' || errorResponse.error.errors[0].message == 'Full authentication is required to access this resource')) {
        localStorage.clear();
        const baseUrl = this.occEndPoint.getBaseUrl({
          baseUrl: true,
          prefix: false,
          baseSite: false,
        });
        setTimeout(
          window.location.href= `${baseUrl}/samlsinglesignon/saml/?asm=true&site=${this.baseSiteId}`, 1000);
      }
      // this.globalMessageService.add(
      //   errorResponse.error.errors[0].message,
      //   GlobalMessageType.MSG_TYPE_ERROR
      // );
    } 
  }
}